import { consumptionAPI } from "./clients";
const ENDPOINT = `/entity_lookup`;

/**
 * endpoint to get the list of all entities for lookup
 * @param {*} data
 * @param {String} data.entity_id Id of the entity
 * @param {Number} page_id Current page number to be displayed
 * @param {Array[Strings]} columns Columns needed to be retreived
 * @param {Array[Object]} filters List of filters needed to be applied to the lookup
 * @param {String} sort_by column id to be used to sort the lookup
 * @param {String} sort_order Sort order to be used to sort the lookup [asc, desc]
 */
const lookupEntities = ({
  entity_id,
  page_id,
  columns,
  filters,
  sort_by,
  sort_order,
}) => {
  return consumptionAPI.post(ENDPOINT, {
    entity_id,
    page_id,
    columns,
    filters,
    sort_by,
    sort_order,
  });
};

export { lookupEntities };
